import { createSlice } from '@reduxjs/toolkit'
const storedYear = localStorage.getItem("acedemicYear");

const initialState = {
  users: [],
  singleUser: null,
  allUsersListLoading: false,
  allUsersListSuccess: null,
  allUsersListError: '',
  allLandingUsersListLoading: false,
  allLandingUsersListSuccess: null,
  allLandingUsersListError: '',
  userDetailsLoading: false,
  userDetailsSuccess: null,
  userDetailsError: '',
  sidebarOpen: false,
  allTeacherByCourse: [],
  adminUserList: [],
  supportListLoading: false,
  supportListSuccess: {},
  supportListError: "",
  ticketReplyLoading: false,
  ticketReplySuccess: {},
  ticketReplyError: {},
  createUserTicketLoading: false,
  createUserTicketSuccess: {},
  createUserTicketError: "",
  userTicketsLoading: false,
  userTicketsSuccess: {},
  userTicketsError: "",
  defaultAcedYr: storedYear ? Number(storedYear) : 0,
  allUsersActivityListLoading: false,
  allUsersActivityListSuccess: null,
  allUsersActivityListError: '',
  allGatePassListLoading: false,
  allGatePassListSuccess: null,
  allGatePassListError: '',
}

export const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    getAllUsers: (state, action) => {
      state.users = action.payload;
    },
    getSingleUser: (state, action) => {
      state.singleUser = action.payload;
    },
    setAllUsersListLoading: (state, action) => {
      state.allUsersListLoading = true;
      state.allUsersListSuccess = null;
      state.allUsersListError = '';
    },
    setAllUsersListSuccess: (state, action) => {
      state.allUsersListLoading = false;
      state.allUsersListSuccess = action.payload;
      state.allUsersListError = '';
    },
    setAllUsersListError: (state, action) => {
      state.allUsersListLoading = false;
      state.allUsersListSuccess = null;
      state.allUsersListError = action.payload;
    },
    setLandingUsersListLoading: (state, action) => {
      state.allLandingUsersListLoading = true;
      state.allLandingUsersListSuccess = null;
      state.allLandingUsersListError = '';
    },
    setLandingUsersListSuccess: (state, action) => {
      state.allLandingUsersListLoading = false;
      state.allLandingUsersListSuccess = action.payload;
      state.allLandingUsersListError = '';
    },
    setLandingUsersListError: (state, action) => {
      state.allLandingUsersListLoading = false;
      state.allLandingUsersListSuccess = null;
      state.allLandingUsersListError = action.payload;
    },
    setUserDetailsLoading: (state, action) => {
      state.userDetailsLoading = true;
      state.userDetailsSuccess = null;
      state.userDetailsError = '';
    },
    setUserDetailsSuccess: (state, action) => {
      state.userDetailsLoading = false;
      state.userDetailsSuccess = action.payload;
      state.userDetailsError = '';
    },
    setUserDetailsError: (state, action) => {
      state.userDetailsLoading = false;
      state.userDetailsSuccess = null;
      state.userDetailsError = action.payload;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = !state.sidebarOpen
    },
    closeSidebar: (state, action) => {
      state.sidebarOpen = false
    },
    setTeacherList: (state, action) => {
      state.allTeacherByCourse = action.payload.data.map((item) => ({ ...item, value: item.id, label: item.name }))
    },
    resetTeacherCourse: (state, action) => {
      state.allTeacherByCourse = []
    },
    setAdminUserList: (state, action) => {
      state.adminUserList = action.payload.data.map((item) => ({ ...item, label: item.name, value: item.id }))
    },
    setAdminSupportListLoading: (state, action) => {
      state.supportListLoading = true
    },
    setAdminSupportListSuccess: (state, action) => {
      state.supportListLoading = false
      state.supportListSuccess = action.payload

    },
    setAdminUserListError: (state, action) => {
      state.supportListLoading = false
      state.supportListError = action.payload.message
    },
    setTicketReplyLoading: (state, action) => {
      state.ticketReplyLoading = true
      state.ticketReplySuccess = {};
      state.ticketReplyError = ""
    },
    setTicketReplySuccess: (state, action) => {
      state.ticketReplyLoading = false
      state.ticketReplySuccess = action.payload
      state.ticketReplyError = ""
    },
    setTicketReplyError: (state, action) => {
      state.ticketReplyLoading = false
      state.ticketReplySuccess = {};
      state.ticketReplyError = action.payload.message
    },
    setCreateUserTicketLoading: (state, action) => {
      state.createUserTicketLoading = true
    },
    setCreateUserTicketSuccess: (state, action) => {
      state.createUserTicketLoading = false
      state.createUserTicketSuccess = action.payload

    },
    setCreateUserTicketError: (state, action) => {
      state.createUserTicketLoading = false
      state.createUserTicketSuccess = {}
      state.createUserTicketError = action.payload.message
    },

    setUserTicketLoading: (state, action) => {
      state.userTicketsLoading = true
      state.userTicketsSuccess = {}
      state.userTicketsError = ""
    },
    setUserTicketSuccess: (state, action) => {
      state.userTicketsLoading = false
      state.userTicketsSuccess = action.payload
      state.userTicketsError = ""
    },
    setUserTicketError: (state, action) => {
      state.userTicketsLoading = false
      state.userTicketsSuccess = {}
      state.userTicketsError = action.payload.message
    },
    resetCreateUserDetails: (state, action) => {
      state.createUserTicketLoading = false
      state.createUserTicketSuccess = {}
      state.createUserTicketError = ""
    },
    resetReplyDetails: (state, action) => {
      state.ticketReplyLoading = false
      state.ticketReplySuccess = {};
      state.ticketReplyError = ""
    },
    setAcedemicYear: (state, action) => {
      state.defaultAcedYr = action.payload;
      localStorage.setItem("acedemicYear", Number(action.payload));
    },
    setAllUsersActivityListLoading: (state, action) => {
      state.allUsersActivityListLoading = true;
      state.allUsersActivityListSuccess = null;
      state.allUsersActivityListError = '';
    },
    setAllUsersActivityListSuccess: (state, action) => {
      state.allUsersActivityListLoading = false;
      state.allUsersActivityListSuccess = action.payload;
      state.allUsersActivityListError = '';
    },
    setAllUsersActivityListError: (state, action) => {
      state.allUsersActivityListLoading = false;
      state.allUsersActivityListSuccess = null;
      state.allUsersActivityListError = action.payload;
    },
    setAllGatePassListLoading: (state, action) => {
      state.allGatePassListLoading = true;
      state.allGatePassListSuccess = null;
      state.allGatePassListError = '';
    },
    setAllGatePassListSuccess: (state, action) => {
      state.allGatePassListLoading = false;
      state.allGatePassListSuccess = action.payload;
      state.allGatePassListError = '';
    },
    setAllGatePassListError: (state, action) => {
      state.allGatePassListLoading = false;
      state.allGatePassListSuccess = null;
      state.allGatePassListError = action.payload;
    },
    resetUserData: (state, action) => {
      state.userDetailsSuccess = null;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setAdminUserList, resetTeacherCourse,
  setTeacherList, getAllUsers, getSingleUser,
  setAllUsersListLoading, setAllUsersListSuccess,
  setAllUsersListError,
  setLandingUsersListLoading, setLandingUsersListSuccess,
  setLandingUsersListError, setUserDetailsLoading,
  setUserDetailsSuccess, setUserDetailsError,
  setSidebarOpen,
  closeSidebar,
  setAdminSupportListLoading,
  setAdminSupportListSuccess,
  setAdminUserListError,
  setTicketReplySuccess,
  setTicketReplyLoading,
  setTicketReplyError,
  setUserTicketLoading,
  setUserTicketSuccess,
  setUserTicketError,
  setCreateUserTicketLoading,
  setCreateUserTicketSuccess,
  setCreateUserTicketError,
  resetCreateUserDetails,
  resetReplyDetails,
  resetUserData,
  setAcedemicYear,
  setAllUsersActivityListLoading,
  setAllUsersActivityListSuccess,
  setAllUsersActivityListError,
  setAllGatePassListLoading,
  setAllGatePassListSuccess,
  setAllGatePassListError,
} = userSlice.actions

export default userSlice.reducer;